<mh-assessment-navigator-question [question]="question" (answered)="onAnswer($event)"></mh-assessment-navigator-question>
<mh-assessment-navigator-question *ngFor="let subQuestion of linkedQuestions"
                                  [question]="subQuestion" (answered)="onAnswer($event)"></mh-assessment-navigator-question>
